export const REPORT_ROLE_VISIBILITY_LANGUAGE_FALLBACK = 0
export const OTHER_REPORTS_FAMILY_ID = 'other'
export const OTHER_REPORTS_FAMILY_TITLE = 'Другие отчёты'

export const reportFamilies = [
  {
    id: 'administration',
    title: 'Администрирование',
    reports: [
      { title: 'Договоры', urls: ['/reports/contract-report'] },
      { title: 'История изменений', urls: ['/reports/change-history'] },
      { title: 'Кабинеты/Аудитории', urls: ['/reports/audiences'] },
    ],
  },
  {
    id: 'finance',
    title: 'Финансы',
    reports: [
      { title: 'Оплаты', urls: ['/reports/paymentsV2', '/reports/payments'] },
      { title: 'Должники и ручные оплаты', urls: ['/reports/debtor-payment'] },
      { title: 'Фин. Отчеты', urls: ['/reports/financial-countdown'] },
      {
        title: 'Отчет по зарплате',
        urls: ['/reports/total-salary', '/reports/wages'],
      },
      {
        title: 'Отчет по сливам',
        urls: ['/reports/left-students-report', '/reports/plums'],
      },
    ],
  },
  {
    id: 'education',
    title: 'Учебный процесс',
    reports: [
      {
        title: 'Инд. занятия',
        urls: ['/reports/private-lesson', '/reports/private-owners'],
      },
      {
        title: 'Групповые занятия',
        urls: [
          '/reports/group-lesson',
          '/reports/group-reports',
          '/reports/group-overview',
        ],
      },
      {
        title: 'Групповые. Оплата по занятиям',
        urls: ['/reports/group-lesson-payment'],
      },
      {
        title: 'Доп. активности',
        urls: ['/reports/additional-activities'],
      },
      {
        title: 'Динамика занятий активных учащихся',
        urls: ['/reports/active-student-lesson-dynamics'],
      },
    ],
  },
  {
    id: 'progress',
    title: 'Успеваемость и контроль',
    reports: [
      {
        title: 'Отчет по проверкам',
        urls: ['/reports/homework-statistics/seminarians'],
      },
      { title: 'Аналитика по курсу', urls: ['/reports/course-analytics'] },
      { title: 'Дашборды из Элжура', urls: ['/reports/journal-dashboards'] },
      {
        title: 'Выполняемость работ',
        urls: ['/reports/homework-statistics/students'],
      },
      {
        title: 'Аналитика ДЗ',
        urls: ['/reports/homework', '/reports/dz-analytics'],
      },
      { title: 'Задавание ДЗ: план/факт', urls: ['/reports/homework-plan'] },
      { title: 'Новый отчет для родителей', urls: ['/reports/for-parents'] },
    ],
  },
  {
    id: 'achievements',
    title: 'Достижения учащихся',
    reports: [
      { title: 'Отчет по сертификатам', urls: ['/reports/certificates'] },
      { title: 'Рейтинг', urls: ['/reports/user-rating'] },
    ],
  },
]

export const reportFamilyItems = reportFamilies.flatMap((family) =>
  family.reports.map((report) => ({
    ...report,
    familyId: family.id,
    familyTitle: family.title,
  })),
)

export const findReportFamilyItemByUrl = (url?: string) =>
  reportFamilyItems.find((report) => report.urls.includes(url ?? ''))

export const reportFamilyOptions = [
  ...reportFamilies.map(({ id, title }) => ({ value: id, label: title })),
  {
    value: OTHER_REPORTS_FAMILY_ID,
    label: OTHER_REPORTS_FAMILY_TITLE,
  },
]

const reportFamilyIds = new Set(
  reportFamilyOptions.map((family) => family.value),
)

export const resolveReportFamilyId = (
  url?: string,
  familyId?: string | number | null,
) => {
  const normalizedFamilyId = familyId == null ? '' : String(familyId)

  if (reportFamilyIds.has(normalizedFamilyId)) return normalizedFamilyId

  return findReportFamilyItemByUrl(url)?.familyId ?? OTHER_REPORTS_FAMILY_ID
}
